<div class="row" style="margin-top: 10px;">
  <div class="col-lg-3">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.USERNAME" (ngModelChange)="selectItem($event)">
        <option>SELECT</option>
        @for (item of listRoutes; track item) {
          <option value="{{item.OneLoginID}}">{{item.PAYROLL_NAME}}</option>
        }
      </select>
      <label for="">Roster name *</label>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group has-float-label">
      <input [(ngModel)]="resource.RESOURCE_ID" class="form-control" id="" type="text"
        placeholder="Resource ID" disabled=""/>
        <label for="">Resource ID</label>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group has-float-label">
        <input [(ngModel)]="resource.ADP_ID" class="form-control" id="" type="text"
          placeholder="APP ID" disabled=""/>
          <label for="">ADP ID</label>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group has-float-label">
          <input [(ngModel)]="resource.START_DATE" class="form-control" id="" type="text"
            placeholder="Start Date" disabled=""/>
            <label for="">Start Date</label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group has-float-label">
            <input [(ngModel)]="resource.ADP_DEPARTMENT" class="form-control" id="" type="text"
              placeholder="Departament" disabled=""/>
              <label for="">Departament</label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group has-float-label">
              <input [(ngModel)]="resource.USEREMAIL" class="form-control" id="" type="text"
                placeholder="Email Address" disabled=""/>
                <label for="">Email Addres</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.ACTIVE" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  <option value="TRUE">TRUE</option>
                  <option value="FALSE">FALSE</option>
                </select>
                <label for="">Active *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.EMPLOYER" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listVendor; track item) {
                    <option value="{{item.ID}}">{{item.DESCRIPTION}}</option>
                  }
                </select>
                <label for="">Vendor *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.CONTRACT" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listContract; track item) {
                    <option value="{{item.ID}}">{{item.DESCRIPTION}}</option>
                  }
                </select>
                <label for="">Contract *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.ADPLEVEL" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  <option value="Level 1">Level 1</option>
                  <option value="Level 1 – Extended">Level 1 – Extended</option>
                  <option value="Level 2">Level 2</option>
                </select>
                <label for="">ADP Level *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.BILLABLE" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  <option value="TRUE">TRUE</option>
                  <option value="FALSE">FALSE</option>
                </select>
                <label for="">Billable *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.UNIT" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  <option value="HOURS">HOURS</option>
                  <option value="MONTH(S)">MONTH(S)</option>
                </select>
                <label for="">Billing Unit *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.EXTERNAL" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  <option value="TRUE">TRUE</option>
                  <option value="FALSE">FALSE</option>
                </select>
                <label for="">External *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.TEAM" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listTeam; track item) {
                    <option value="{{item.ID}}">{{item.DESCRIPTION}}</option>
                  }
                </select>
                <label for="">Team *</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.CHAPTER" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listChapter; track item) {
                    <option value="{{item.value}}">{{item.text}}</option>
                  }
                </select>
                <label for="">Chapter</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.PRIMARY_CAPEX_TASK" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listPrimaryTask; track item) {
                    <option value="{{item.value}}">{{item.text}}</option>
                  }
                </select>
                <label for="">Primary Task</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.TYPE" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listType; track item) {
                    <option value="{{item.value}}">{{item.text}}</option>
                  }
                </select>
                <label for="">Type</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.CAPEXCODE" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listCapexCode; track item) {
                    <option value="{{item.value}}">{{item.text}}</option>
                  }
                </select>
                <label for="">CAPEX Code</label>
              </div>
            </div>
            <div class="col-lg-4">
              &nbsp;
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.ADO_USERID" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listAdo; track item) {
                    <option value="{{item.USERID}}">{{item.USERNAME}}</option>
                  }
                </select>
                <label for="">ADO User Name</label>
              </div>
            </div>
            <div class="col-lg-4">
              &nbsp;
            </div>
            <div class="col-lg-4">
              <div class="form-group has-float-label">
                <select class="form-control" [(ngModel)]="resource.ME_USERID" (ngModelChange)="resource.updated = true">
                  <option>SELECT</option>
                  @for (item of listManageEngine; track item) {
                    <option value="{{item.USER_ID}}">{{item.FIRST_NAME}}</option>
                  }
                </select>
                <label for="">Manage Engine User Name</label>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="col-lg-4" style="float: right;">
                <button type="submit" class="btn btn-sm btn-block btn-danger claroredbg" (click)="saveResources()"><i class="fa fa-save"></i> Save</button>
              </div>
            </div>
          </div>
